var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditBlueRound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 12.5,
    fill: "#255986",
    stroke: "#FDFDFE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 16.4997V18.9997H9.5L16.8733 11.6264L14.3733 9.12638L7 16.4997ZM18.8067 9.69305C19.0667 9.43305 19.0667 9.01305 18.8067 8.75305L17.2467 7.19305C16.9867 6.93305 16.5667 6.93305 16.3067 7.19305L15.0867 8.41305L17.5867 10.913L18.8067 9.69305Z",
    fill: "#EFF3F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditBlueRound);
export default __webpack_public_path__ + "static/media/edit-blue-round.a3a83936a89edf249388db2a87818696.svg";
export { ForwardRef as ReactComponent };